// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryHeader";
import myAccountFilterSectionStyles from "@tps/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";

headerStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
};

headerStyles.invoiceCountGridItem = {
    ...myAccountFilterSectionStyles.countGridItem,
};

headerStyles.toggleFilterGridItem = {
    ...myAccountFilterSectionStyles.toggleFilterGridItem,
};

headerStyles.toggleFilterButton = {
    ...myAccountFilterSectionStyles.toggleFilterButton,
};

headerStyles.toggleFilterButtonIcon = {
    ...myAccountFilterSectionStyles.toggleFilterButtonIcon,
};

headerStyles.heading = {
    ...myAccountFilterSectionStyles.searchFormStyles.headingText,
};
